import { render, staticRenderFns } from "./Classtableleft.vue?vue&type=template&id=22ef5329&scoped=true&"
import script from "./Classtableleft.vue?vue&type=script&lang=js&"
export * from "./Classtableleft.vue?vue&type=script&lang=js&"
import style0 from "./Classtableleft.vue?vue&type=style&index=0&id=22ef5329&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ef5329",
  null
  
)

export default component.exports